/**
 * Utilitários para máscaras e validações de CPF e WhatsApp
 * Implementação cirúrgica para Settings.tsx
 */

/**
 * Aplica máscara de CPF: 000.000.000-00
 */
export const maskCPF = (value: string): string => {
  // Remove tudo que não é dígito
  const numbers = value.replace(/\D/g, '');
  
  // Limita a 11 dígitos
  const limited = numbers.slice(0, 11);
  
  // Aplica a máscara
  if (limited.length <= 3) {
    return limited;
  } else if (limited.length <= 6) {
    return `${limited.slice(0, 3)}.${limited.slice(3)}`;
  } else if (limited.length <= 9) {
    return `${limited.slice(0, 3)}.${limited.slice(3, 6)}.${limited.slice(6)}`;
  } else {
    return `${limited.slice(0, 3)}.${limited.slice(3, 6)}.${limited.slice(6, 9)}-${limited.slice(9)}`;
  }
};

/**
 * Aplica máscara de telefone brasileiro: (00) 00000-0000
 */
export const maskPhoneBR = (value: string): string => {
  // Remove tudo que não é dígito
  const numbers = value.replace(/\D/g, '');
  
  // Limita a 11 dígitos
  const limited = numbers.slice(0, 11);
  
  // Aplica a máscara
  if (limited.length <= 2) {
    return limited;
  } else if (limited.length <= 7) {
    return `(${limited.slice(0, 2)}) ${limited.slice(2)}`;
  } else {
    return `(${limited.slice(0, 2)}) ${limited.slice(2, 7)}-${limited.slice(7)}`;
  }
};

/**
 * Remove máscara do CPF, deixando apenas números
 */
export const removeCPFMask = (value: string): string => {
  return value.replace(/\D/g, '');
};

/**
 * Remove máscara do telefone, deixando apenas números
 */
export const removePhoneMask = (value: string): string => {
  return value.replace(/\D/g, '');
};

/**
 * Valida se CPF está no formato correto: 000.000.000-00
 */
export const isCPFFormatted = (value: string): boolean => {
  if (!value) return true; // Campo vazio é válido
  
  const numbers = removeCPFMask(value);
  
  // Deve ter exatamente 11 dígitos
  if (numbers.length !== 11) return false;
  
  // Deve estar no formato correto
  const regex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
  return regex.test(value);
};

/**
 * Valida se telefone está no formato correto: (00) 00000-0000
 */
export const isPhoneFormatted = (value: string): boolean => {
  if (!value) return true; // Campo vazio é válido
  
  const numbers = removePhoneMask(value);
  
  // Deve ter exatamente 11 dígitos
  if (numbers.length !== 11) return false;
  
  // Deve estar no formato correto
  const regex = /^\(\d{2}\) \d{5}-\d{4}$/;
  return regex.test(value);
};